import type { Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauDenumeroterAction from '../actions/BordereauDenumeroterAction';
import BaseBordereauState from './BaseBordereauState';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import MouvementDupliquerAction from '../../mouvements/liquidation/actions/MouvementDupliquerAction';
import BordereauRelancerFluxAction from '../actions/BordereauRelancerFluxAction';
import BordereauRejeterCollectiviteAction from '../actions/BordereauRejeterCollectiviteAction';

class BordereauRefuseState extends BaseBordereauState {
  constructor() {
    super();
    this.step = BordereauStateStep.REFUSE;
    this.state = BordereauStateType.REFUSE;
    this.color = '#FF5731';
    this.libelle = 'Refusé';
  }

  getBordereauActions(
    _bordereau: BordereauWithState,
    userRole: UserRole,
  ) : BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
    return [
      new BordereauRelancerFluxAction({ isActionPrincipale: true }),
      new BordereauRejeterCollectiviteAction(),
      new BordereauDupliquerAction(),
      ...(userRole === UserRole.ADMIN) ? [
        new BordereauDenumeroterAction({ isSuperUser: true }),
        new BordereauModifierAction({ isSuperUser: true }),
      ] : [],
    ];
  }

  getMouvementActions(userRole : UserRole): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
    return [
      new MouvementModifierAction({ isReadonly: true }),
      new MouvementDupliquerAction(),
      ...(userRole === UserRole.ADMIN) ? [
        new MouvementModifierAction({ isSuperUser: true }),
      ] : [],
    ];
  }
}

export default BordereauRefuseState;
